'use client';

import HeroSection from '@containers/HeroSection';
import Main from '@containers/Main';
import Meta from '@containers/Meta';
import BreadCrumbs from '@elements/BreadCrumbs';
import { crumbs } from '@graphql/Seo/BreadCrumb';

const BREAD_CRUMBS = crumbs({ name: 'О компании', url: '/about' });

const About = () => (
  <Main>
    <Meta>
      <title>О компании — Express-Шина</title>
      <meta property="og:type" content="article" />
      <meta property="article:section" content="О компании" />
      <meta name="description" content="Express-Шина — сеть автоцентров по продаже автотоваров" />
    </Meta>
    <BreadCrumbs crumbs={BREAD_CRUMBS} />
    <HeroSection variant="about">
      <HeroSection.Header>Сеть автоцентров по всей России</HeroSection.Header>
      <HeroSection.Text>
        Первая шиномонтажная мастерская и интернет-магазин шин и дисков «Express-Шина» открылись в Екатеринбурге в
        2006-м году. Сегодня мы продаем летние и зимние шины для легковых автомобилей и внедорожников, литые, кованые и
        штампованные диски более чем в 20 городах России
      </HeroSection.Text>
    </HeroSection>
  </Main>
);

export default About;
